import React, { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchFinance } from "utils/api";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import s from "./ConfigContent.module.scss";

const ConfigContent = ({ handleInput, handleDataFormat, isDialogEditing }) => {
  const { t } = useTranslation();
  const [datasource, setDatasource] = useState([]);
  const [focus, setFocus] = useState({});

  const inputOnChange = (e, field) => {
    const regex = /^\d*(\.\d{1,6})?$/g;
    const { value } = e.target;
    const isValidInput = regex.test(value);
    if (!isValidInput) {
      return;
    }
    handleInput(+Number(value).toFixed(6), field);
  };
  const inputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const inputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  const currencyList = [
    "USD",
    "TWD",
    "THB",
    "SGD",
    "KRW",
    "JPY",
    "GBP",
    "EUR",
    "CAD",
    "AUD",
  ];

  useLayoutEffect(() => {
    initialFetch();
  }, []);

  const initialFetch = async () => {
    try {
      const res = await fetchFinance("/action", {
        action: "getFxRateConfig",
      });
      if (!res) {
        return;
      }
      if (res && res.responseCode === "0000") {
        const sortedDataArray = sortArray(currencyList, res.data);
        setDatasource(sortedDataArray);
        const formattedDataArray = handleUpdateDataFormat(sortedDataArray);
        handleDataFormat(formattedDataArray);
      }
    } catch (error) {
      console.log({ getFxRateConfigError: String(error) });
      return;
    }
  };

  const sortArray = (list, originalArray) => {
    const tempArray = [];
    for (const item of list) {
      const targetObj = originalArray.find((obj) => obj.currencyCode === item);
      tempArray.push(targetObj);
    }
    return tempArray;
  };

  const handleUpdateDataFormat = (originalArray) => {
    let tempObj = {};
    for (const obj of originalArray) {
      tempObj = {
        ...tempObj,
        [obj.currencyCode]: obj.rate,
      };
    }
    return tempObj;
  };

  return (
    <div className={s.configContainer}>
      <div>
        <table className={s.configTable}>
          <thead>
            <tr>
              <td className={s.td}>
                {t("page.finance.fxRate.fx.rate.config.dialog.table.title.1")}
              </td>
              <td className={s.td}>
                {t("page.finance.fxRate.fx.rate.config.dialog.table.title.2")}
              </td>
            </tr>
          </thead>
          <tbody>
            {isDialogEditing ? (
              <>
                {datasource.length !== 0 && (
                  <>
                    {datasource.map((item) => {
                      return (
                        <tr key={item.currencyCode} className={s.tr}>
                          <td className={s.td}>{item.currencyCode}</td>
                          <td className={s.td}>
                            <div style={{ backgroundColor: "white" }}>
                              <OutlinedText
                                defaultValue={item.rate ? item.rate : 0}
                                noErrorMessage
                                onchangeFn={(e) =>
                                  inputOnChange(e, item.currencyCode)
                                }
                                onfocusFn={() =>
                                  inputOnFocus(item.currencyCode)
                                }
                                onblurFn={() => inputOnBlur(item.currencyCode)}
                                sxParams={{
                                  textFocus: focus[item.currencyCode],
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </>
            ) : (
              <>
                {datasource.length !== 0 && (
                  <>
                    {datasource.map((item) => {
                      return (
                        <tr key={item.currencyCode} className={s.tr}>
                          <td className={s.td}>{item.currencyCode}</td>
                          <td className={s.td}>{item.rate}</td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      {datasource.length !== 0 && (
        <>
          <div className={s.comment}>
            <span>{t("page.finance.fxRate.fx.rate.config.comment")}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(ConfigContent);
